module.exports = __webpack_public_path__ + "media/images/soar/range_icon-316f3fe39efa04d160f3447921fdbc91.svg";